<template>
  <div class="fillable-document">
    <v-img
      :src="require('@/assets/svg/confirmation-icon.svg')"
      class="mb-5 mt-5"
      height="140"
      contain
    />
    <div class="mb-5">To complete this form follow the following steps</div>
    <div class="document-step">
      <div class="progress">1</div>
      <div class="mt-1">
        <span class="font-weight-bold">
          Download form
        </span>
        <FileComponent
          class="py-2"
          :file="document"
          customActions
          disabled
          disablePreview
          downloadDirectly
        />
      </div>
    </div>
    <div class="document-step">
      <div class="progress">2</div>
      <div class="d-flex flex-column">
        <span class="font-weight-bold">
          Upload completed form and submit for approval
        </span>
        <span>
          To complete the form, open the file on a desktop computer and use a
          program such as Acrobat Reader on Windows or Preview on a Mac to open
          the file. You can also print off and fill in the form by hand, and
          upload a scan of the form.
        </span>
        <FileUpload
          class="mt-5"
          @unselectFile="unselectFile"
          @selectFile="selectFile"
          :files="uploadedFiles"
          :fileTypes="['application/pdf']"
          disableAutoProceed
          customActions
        />
      </div>
    </div>
    <InformationDocument
      v-if="size(uploadedFiles)"
      :document="first(uploadedFiles)"
      hideDownload
    />
  </div>
</template>
<script>
import FileComponent from "@/components/common/FileComponent";
import InformationDocument from "@/components/documents/InformationDocument";
import FileUpload from "@/components/common/FileUpload";
import { getFilePreviewSettings } from "@/utils/files";
import { first, size } from "lodash";

export default {
  components: {
    FileComponent,
    FileUpload,
    InformationDocument
  },
  props: {
    document: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      uploadedFiles: [],
      fileDialog: { dialog: false }
    };
  },
  methods: {
    selectFile({ file }) {
      this.uploadedFiles.push(file);
      this.$emit("onFileChanged", file);
    },
    async showFile(file) {
      const filePreviewSettings = await getFilePreviewSettings(file);
      this.fileDialog = {
        ...filePreviewSettings,
        dialog: true
      };
    },
    unselectFile({ uppyInstance }) {
      this.uploadedFiles = [];
      this.$emit("onFileChanged", null);
      uppyInstance.reset();
    },
    first,
    size
  }
};
</script>

<style lang="scss">
.fillable-document {
  .document-step {
    display: flex;
    margin-bottom: 20px;

    .progress {
      flex-shrink: 0;
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $white;
      background-color: $river-bed;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 10px;
    }
  }
}
</style>
